import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMAGE_SRC } from '../../../shared-constants';
import { DISPLAY_CONSTS } from './table-header.constants';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
  standalone: false,
})
export class TableHeaderComponent {
  @Input() hasAltHeader = false;

  //Shortcut to hide all buttons
  @Input() hasNoButtons = false;

  //Header
  @Input() headerText!: string;
  @Input() hasHeader = true;

  //ShowingResults
  @Input() numResults = 0;
  @Input() hasShowingResultsText = false;

  //Clear Filter
  @Input() hasFilter = true;
  @Input() filterDisabled = false;
  @Output() clearFilterEvent = new EventEmitter();

  //Export Excel
  @Input() hasExcel = true;
  @Input() excelDisabled = false;
  @Output() exportExcelEvent = new EventEmitter();

  //Edit Item
  @Input() hasEditIcon = false;
  @Input() editIconDisabled = false;

  //Add New Item
  @Input() hasAddItem = true;
  @Input() addItemDisabled = false;
  @Input() hasAlternateAddItem = false;
  @Input() hasSingleAlternateAddItem = false;
  @Input() alternateAddItemSrc = IMAGE_SRC.OPERATIONS_STOP;
  @Input() alternateAddButtonText = DISPLAY_CONSTS.ADD_STOP;
  @Input() addButtonText = DISPLAY_CONSTS.ADD_DELIVERY;

  //Delete Item
  @Input() hasDeleteIcon = false;
  @Input() deleteDisabled = false;

  //File Upload
  @Input() hasFileUpload = false;
  @Input() fileUploadText = '';

  //File Download
  @Input() hasFileDownload = false;
  @Input() fileDownloadText = '';

  @Output() addItemEvent = new EventEmitter<boolean>();

  //Search Bar
  @Input() hasSearchBar = false;
  @Input() searchBarDisabled = false;
  @Output() searchEvent = new EventEmitter();
  @Output() searchClear = new EventEmitter();

  //Radio Button
  @Input() firstOptionValue!: string;
  @Input() firstOptionName!: string;
  @Input() secondOptionValue!: string;
  @Input() secondOptionName!: string;
  @Input() radioHeader!: string;
  @Input() hasRadioButton = false;
  @Input() radioButtonDisabled = false;
  @Input() radioModel!: string;
  @Output() exportRadioButtonChange = new EventEmitter<Event>();
  @Output() deleteEvent = new EventEmitter<Event>();
  @Output() editEvent = new EventEmitter<Event>();
  @Output() fileUploadEvent = new EventEmitter<Event>();
  @Output() fileDownloadEvent = new EventEmitter<Event>();

  //Padding
  @Input() rightPadding = 5;
  @Input() hasCollapsedPadding = true;

  readonly DISP_CONSTANTS = DISPLAY_CONSTS;
  readonly IMAGES = IMAGE_SRC;

  sendAddItemSignal($event: boolean) {
    this.addItemEvent.emit($event);
  }

  sendFilterSignal() {
    this.clearFilterEvent.emit();
  }

  sendExportExcelSignal() {
    this.exportExcelEvent.emit();
  }

  sendDeleteSignal() {
    this.deleteEvent.emit();
  }

  sendEditSignal() {
    this.editEvent.emit();
  }

  sendFileUploadSignal() {
    this.fileUploadEvent.emit();
  }

  sendFileDownloadSignal() {
    this.fileDownloadEvent.emit();
  }

  sendSearchSignal($event: Event) {
    this.searchEvent.emit(($event?.target as HTMLInputElement).value);
  }

  sendSearchClear() {
    this.searchClear.emit();
  }

  sendRadioButtonChange($event: Event) {
    this.exportRadioButtonChange.emit($event);
  }
}
